<template>
  <div class="view-box nick-name">
    <navBan title="修改昵称"></navBan>
    <div class="input-box" style="margin-top: 32px">
      <input v-model="nickName" placeholder="请输入新昵称" minlength="2" maxLength="20" type="text">
      <div v-if="nickName!==''" @click="nickName=''" class="suffix-box">
        <img class="suffix" src="../../assets/images/mobile/clear.svg" alt="">
      </div>
      <p class="input-msg">2-20个字，可由中英文、数字组成</p>
    </div>
    <button @click="submitForm" class="button" :class="{ 'button-disabled': !showbtn }" :disabled="!showbtn">保存</button>
  </div>
</template>

<script setup>
import navBan from '@/components/navBan';
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { formState, onSubmit } from '@/utils/setup/userInfo';
import Schema from 'async-validator';
import { Toast } from 'vant';

const router = useRouter();
const route = useRoute();
let nickName = ref('');
let showbtn = computed(() => {
  return nickName.value.length > 1;
});

const name = route.query.nickName;
if (name) {
  nickName.value = name;
}

function submitForm () {
  const validator = new Schema({
    nickName: { required: true, message: '请输入昵称' }
  });
  validator.validate({ nickName: nickName.value }, async function (errors, fields) {
    if (errors) {
      Toast(errors[0].message);
      return false;
    }

    formState.nickName = nickName.value;
    await onSubmit(false);
    router.go(-1);
  });
}
</script>

<style lang="scss" scoped>
.view-box{padding-top:1px;}
.nick-name {
  .input-box {
    input {
      padding-left: 16px;
    }
  }
  .button {
    margin-top: 16px;
  }
}
</style>
